var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallengeStart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1C21 7.66667 17 21 1 21C7.66667 21 21 25 21 41C21 34.3333 25 21 41 21C34.3333 21 21 17 21 1Z",
    fill: "#FCCE2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.5C0.723858 20.5 0.5 20.7239 0.5 21C0.5 21.2761 0.723858 21.5 1 21.5V20.5ZM21.5 1C21.5 0.723858 21.2761 0.5 21 0.5C20.7239 0.5 20.5 0.723858 20.5 1L21.5 1ZM20.5 41C20.5 41.2761 20.7239 41.5 21 41.5C21.2761 41.5 21.5 41.2761 21.5 41H20.5ZM41 21.5C41.2761 21.5 41.5 21.2761 41.5 21C41.5 20.7239 41.2761 20.5 41 20.5V21.5ZM1 21.5C9.16296 21.5 14.3131 18.0876 17.4058 13.7922C20.4801 9.52223 21.5 4.41335 21.5 1H20.5C20.5 4.25332 19.5199 9.14443 16.5942 13.2078C13.6869 17.2458 8.83704 20.5 1 20.5V21.5ZM21.5 41C21.5 32.837 18.0876 27.6869 13.7922 24.5942C9.52223 21.5199 4.41334 20.5 1 20.5V21.5C4.25332 21.5 9.14443 22.4801 13.2078 25.4058C17.2458 28.3131 20.5 33.163 20.5 41H21.5ZM41 20.5C32.837 20.5 27.6869 23.9124 24.5942 28.2078C21.5199 32.4778 20.5 37.5867 20.5 41H21.5C21.5 37.7467 22.4801 32.8556 25.4058 28.7922C28.3131 24.7542 33.163 21.5 41 21.5V20.5ZM20.5 1C20.5 9.16296 23.9124 14.3131 28.2078 17.4058C32.4778 20.4801 37.5867 21.5 41 21.5V20.5C37.7467 20.5 32.8556 19.5199 28.7922 16.5942C24.7542 13.6869 21.5 8.83704 21.5 1L20.5 1Z",
    fill: "#FCCE2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeStart);
export default __webpack_public_path__ + "static/media/challenge-start.dfec09f7cfbfbe40748019757b3de17f.svg";
export { ForwardRef as ReactComponent };